/**
 * This is helper class will be utilized for Omnichannel configuration
 */
import _isEmpty from 'lodash/isEmpty';
import Page from './page';
import i18n from './reacti18n';

// Get Remote config for Ominichannel config from window
export const getOmnichannelConfig = () => {
  try {
    if (window && window.omniChannelConfig) {
      return window.omniChannelConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

export const returnRefIDforIntentCode = (intentCode) => {
  const omniConfig = getOmnichannelConfig().setContext.supportedIntents;
  return Object.keys(omniConfig).find((key) => omniConfig[key] === intentCode) || '';
};

// this funciton is used to validate whether setContext wired-on /off ?
export const isSetContextFeatureWiredOn = (config) => {
  if (!_isEmpty(config) && !_isEmpty(config.setContext)) {
    return (config.setContext.isFeatureWiredON || false);
  }
  return false;
};

// this funciton is used to validate whether  isSetContextEnabledGlobally ?
export const isSetContextEnabledGlobally = (config) => {
  if (!_isEmpty(config) && !_isEmpty(config.setContext)) {
    return (config.setContext.isEnabledGlobally || false);
  }
  return false;
};

// Check if it setContext is enabled
export const isMarketEnabledForSetContext = (config) => {
  const country = (Page.getCountry()).toUpperCase();
  const locale = Page.getAPILocalilty();
  if (!_isEmpty(config) && !_isEmpty(config.setContext)) {
    const enabledMarkets = config.setContext.enabledMarkets;
    if (enabledMarkets) {
      return enabledMarkets.split(',')
        .filter((market) => market.indexOf(`${country}:`) >= 0)
        .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0)
        .length > 0;
    }
  }
  return false;
};

export const isSetContextEnabledFromRC = () => {
  const config = getOmnichannelConfig();
  if (isSetContextFeatureWiredOn(config) && (isSetContextEnabledGlobally(config) || isMarketEnabledForSetContext(config))) return true;
  // default return false;
  return false;
};

export const getStandardIntent = (topicRefId) => {
  const config = getOmnichannelConfig();
  if (!_isEmpty(config) && !_isEmpty(config.setContext) && !_isEmpty(config.setContext.supportedIntents)) {
    const standardIntents = config.setContext.supportedIntents;
    if (standardIntents[topicRefId]) {
      return [{ intent_code: standardIntents[topicRefId] }];
    }
  }
  return [];
};

/**
 * Function to check for topic refid in remote config for contact us page
 */
export const isFinalIntentEnabledForSetContext = (topicRefId, responseBody) => {
  // checking for remote config existance and topic refid existance in the remote config
  const arrStandardIntents = getStandardIntent(topicRefId);
  if (arrStandardIntents.length > 0) return arrStandardIntents;

  // checking for tags info in article
  if (responseBody.articleContent && Array.isArray(responseBody.articleContent.tags)
    && responseBody.articleContent.tags.length && Array.isArray(responseBody.articleContent.tags[0].predictions)
    && responseBody.articleContent.tags[0].predictions.length) {
    const articleTags = responseBody.articleContent.tags[0].predictions;
    // Parsing article repsonse by changing intent to customer_intent to pass to set context API
    return articleTags.map(({ intent, score }) => ({ customer_intent: intent, score }));
  }

  // checking for topicrefid if omnichannel standard intents or article tags are not avaialble
  if (topicRefId) {
    return [{ customer_intent: topicRefId }];
  }

  // returning empty array for exception cases
  return [];
};

/**
 * Function to check is key exists in locale property file.
 * Pass key to this function to check whether key exists in property file or not
 * @returns {boolean} true/false
 */
export const isKeyExistInPropertyFile = (filepath, keyValue) => {
  const snowManCode = '%E2%98%83';
  const keyLabel = i18n.message(`${filepath}.${keyValue}`);
  return !(encodeURI(keyLabel).includes(snowManCode));
};

/**
 * Function to check intent code exists in the omni-channel articles
 * Used for both desktop and minihelp/Venice
 */
export const isIntentCodeExists = (omniChannelIntentArticles) => !!(!_isEmpty(omniChannelIntentArticles) && Array.isArray(omniChannelIntentArticles.intentArticleDetails)
    && omniChannelIntentArticles.intentArticleDetails.length > 0 && omniChannelIntentArticles.intentArticleDetails[0].contextMetaData
    && omniChannelIntentArticles.intentArticleDetails[0].contextMetaData.intent && omniChannelIntentArticles.intentArticleDetails[0].contextMetaData.intent.intent_code);
